import AwardCard, { IAwardCard } from "@/components/cards/AwardCard";
import clsx from "clsx";
import { FC, HTMLAttributes, ReactNode } from "react";
import HtmlText from "../common/HtmlText";

type IAwardsSectionProps = HTMLAttributes<HTMLElement> & {
  heading?: string;
  description?: ReactNode;
  awards?: IAwardCard[];
};

const AwardsSection: FC<IAwardsSectionProps> = (props) => {
  const { heading, description, awards, className, ...other } = props;

  return (
    <section
      className={clsx("container py-5 lg:py-8 xl:py-[50px]", className)}
      {...other}
    >
      <div className="w-full font-sans">
        {(heading || description) && (
          <div className="flex flex-col items-center text-center">
            {heading && (
              <h2 className="mb-3 text-h7 font-medium text-black-900 md:mb-5 lg:text-h4 xl:mb-7 xl:text-h3">
                {heading}
              </h2>
            )}

            {description && (
              <HtmlText className="mb-10 w-full !max-w-[920px]">
                {description}
              </HtmlText>
            )}
          </div>
        )}

        {awards && awards.length > 0 && (
          <div className="grid w-full place-items-stretch gap-5 md:grid-cols-2 lg:grid-cols-3 lg:gap-7">
            {awards.map((award, index) => (
              <AwardCard key={index} award={award} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default AwardsSection;
